import { ToolItem, ToolName } from "./allTypes";

export const appList = [
	{
		appId: "ballcup",
		bgImage: require("../assets/icons/ballcup-bg.jpg"),
		titleImage: require("../assets/icons/ballcup-title.png"),
		logo: require("../assets/icons/ballcup-logo.png"),
		url: "https://play.google.com/store/apps/details?id=com.architechgaming.ballcup",
	},
	{
		appId: "spinstack",
		bgImage: require("../assets/icons/spinstack-bg.jpg"),
		titleImage: require("../assets/icons/spinstack-title.png"),
		logo: require("../assets/icons/spinstack-logo.png"),
		url: "https://play.google.com/store/apps/details?id=com.architechgaming.spinstack",
	},
	{
		appId: "beamshot",
		bgImage: require("../assets/icons/beamshot-bg.jpg"),
		titleImage: require("../assets/icons/beamshot-title.png"),
		logo: require("../assets/icons/beamshot-logo.png"),
		url: "https://play.google.com/store/apps/details?id=com.architechgaming.beamshot",
	},
	{
		appId: "pozymatch",
		bgImage: require("../assets/icons/pozymatch-bg.jpg"),
		titleImage: require("../assets/icons/pozymatch-title.png"),
		logo: require("../assets/icons/pozymatch-logo.png"),
		url: "https://play.google.com/store/apps/details?id=com.architechgaming.pozymatch",
	},
	{
		appId: "energyline",
		bgImage: require("../assets/icons/energyline-bg.jpg"),
		titleImage: require("../assets/icons/energyline-title.png"),
		logo: require("../assets/icons/energyline-logo.png"),
		url: "https://play.google.com/store/apps/details?id=com.architechgaming.energyline",
	},
	{
		appId: "dunkypunky",
		bgImage: require("../assets/icons/dunkypunky-bg.jpg"),
		titleImage: require("../assets/icons/dunkypunky-title.png"),
		logo: require("../assets/icons/dunkypunky-logo.png"),
		url: "https://play.google.com/store/apps/details?id=com.architechgaming.dunkypunky",
	},
	{
		appId: "ringoball",
		bgImage: require("../assets/icons/ringoball-bg.jpg"),
		titleImage: require("../assets/icons/ringoball-title.png"),
		logo: require("../assets/icons/ringoball-logo.png"),
		url: "https://play.google.com/store/apps/details?id=com.architechgaming.ringoball",
	},
	{
		appId: "shinimals",
		bgImage: require("../assets/icons/shinimals-bg.jpg"),
		titleImage: require("../assets/icons/shinimals-title.png"),
		logo: require("../assets/icons/shinimals-logo.png"),
		url: "https://play.google.com/store/apps/details?id=com.architechgaming.shinimals",
	},
	{
		appId: "hexahaven",
		bgImage: require("../assets/icons/hexahaven-bg.jpg"),
		titleImage: require("../assets/icons/hexahaven-title.png"),
		logo: require("../assets/icons/hexahaven-logo.png"),
		url: "https://play.google.com/store/apps/details?id=com.architechgaming.hexahaven",
	},
];

export const contactInfo = [
	{
		icon: require("../assets/icons/email.png"),
		text: "yilmazykt@hotmail.com",
		contactId: "email",
	},
	{
		icon: require("../assets/icons/linkedin.png"),
		text: "linkedin/yilmazyakut",
		contactId: "linkedin",
	},
	{
		icon: require("../assets/icons/github.png"),
		text: "github/yilmazyakut",
		contactId: "github",
	},
];
